import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseNotesDto, IBaseService, SingleResponseModel } from 'src/app/tabms/models/base/base';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BaseNotesService } from 'src/app/tabms/services/base/base-notes.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { ConfirmationComponent } from '../../global/confirmation/confirmation.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DELETESUCCESS, EDITSUCCESS, OPERERROR, SAVESUCCESS } from 'src/app/tabms/tab-consts';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-base-notes',
  templateUrl: './base-notes.component.html',
  styleUrl: './base-notes.component.scss'
})
export class BaseNotesComponent implements OnInit, OnDestroy {
  @ViewChild('noteElement') noteElement: ElementRef;
  viewId;
  viewData;
  editId;
  form: FormGroup;
  systemMenuId;
  userId;
  menuKey: string;
  pageParameters: string;

  private destroy$: Subject<void> = new Subject<void>();

  // constructor
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private baseNotesService: BaseNotesService,
    private formBuilder: FormBuilder,
    private baseService: BaseService,
    public dialog: MatDialog,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {
    this.viewId = data.id;
    this.menuKey = data.menuKey;
    this.pageParameters = data.pageParameter;
  }

  ngOnInit(): void {
    this.buildForm();
    this.getData();
  }

  buildForm(): void {
    this.form = this.formBuilder.group({
      note: [null, [Validators.required]],
      menukey: [null],
      pageparameters: [''],
      recordid: [null]
    });
  }

  getData() {
    this.baseNotesService.GetByMenuAndRecordId(this.menuKey, this.pageParameters, this.viewId).subscribe((res: SingleResponseModel<BaseNotesDto[]>) => {
      this.viewData = res.result;
      this.noteElement.nativeElement.focus();
    });

  }

  onSubmit() {
    // let claims = JSON.parse((sessionStorage.getItem('id_token_claims_obj')));
    // if (claims) {
    //   this.userId = claims['sub'];
    // }

    if (this.form.valid) {
      const formData: BaseNotesDto = this.form.value;

      if (!this.editId) {
        formData.menukey = this.menuKey
        formData.recordid = this.viewId;
        formData.pageparameters = this.pageParameters;

        this.baseNotesService.create(formData).subscribe({
          next: (res) => {
            this.baseService.showSuccessMessage(SAVESUCCESS);
            this.form.reset();
            this.getData();
            this.baseService.refreshTable.next(true);
          },
          error: (err) => {
            this.baseService.showErrorMessage(OPERERROR);
          }
        });
      }
      else {
        let editData: BaseNotesDto = {
          id: this.editId,
          menukey: formData.menukey,
          pageparameters: formData.pageparameters,
          recordid: formData.recordid,
          note: formData.note
        };

        this.baseNotesService.update(this.editId, editData).subscribe({
          next: (res) => {
            this.baseService.showSuccessMessage(EDITSUCCESS);
            this.form.reset();
            this.getData();
          },
          error: (err) => {
            this.baseService.showErrorMessage(OPERERROR);
          }

        });
      }
    }
  }

  edit(id) {
    this.editId = id;

    this.baseNotesService.get(this.editId).subscribe((res) => {
      this.form.patchValue(res.result);
    });
  }

  delete(id) {
    let dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '500px',
      direction: this.baseService.getDirection(),
      data: { message: this.translate.instant('DeleteConfirm') }
    });

    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.baseNotesService.delete(id).subscribe((res) => {
          if (res) {
            this.getData();
            this.baseService.showSuccessMessage(DELETESUCCESS);
            this.baseService.refreshTable.next(true);
          }
        },
          (err) => {
            this.baseService.showErrorMessage(OPERERROR);
          });
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
